// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../../../home/krylancelo/tmp/node_modules/Artetia/beta/node_modules/css-loader/index.js??ref--7-1!../../../../../../../../../../../home/krylancelo/tmp/node_modules/Artetia/beta/node_modules/postcss-loader/lib/index.js??postcss!./demo.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../../../../../../../home/krylancelo/tmp/node_modules/Artetia/beta/node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../../../../home/krylancelo/tmp/node_modules/Artetia/beta/node_modules/css-loader/index.js??ref--7-1!../../../../../../../../../../../home/krylancelo/tmp/node_modules/Artetia/beta/node_modules/postcss-loader/lib/index.js??postcss!./demo.css", function() {
			var newContent = require("!!../../../../../../../../../../../home/krylancelo/tmp/node_modules/Artetia/beta/node_modules/css-loader/index.js??ref--7-1!../../../../../../../../../../../home/krylancelo/tmp/node_modules/Artetia/beta/node_modules/postcss-loader/lib/index.js??postcss!./demo.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// /media/krylancelo/OS/Data/Work/krylab/Artetia/beta/src/assets/css/demo.css
// module id = ../../../../../../../../../../../media/krylancelo/OS/Data/Work/krylab/Artetia/beta/src/assets/css/demo.css
// module chunks = styles